<div class="container px-4 py-10">
  <block-ui>
    <div class="w-full p-2 m-2">
      <!-- Header Section -->
      <div class="flex items-center justify-between">
        <div class="mb-7">
          <h1 class="mb-1 text-2xl font-semibold text-primary-200">
            Invoices
          </h1>
          <p class="text-sm text-primary-500">View all of Your Invoices</p>
        </div>
        <div class="flex gap-2">
          <p-button icon="pi pi-download" label="Export" severity="secondary"></p-button>
            <p-button icon="pi pi-plus" label="Add New" severity="primary" (onClick)="addInvoice()"></p-button>
        </div>
      </div>

      <!-- Tabs -->
      <p-tabMenu
        [model]="tabs"
        [activeItem]="activeTab"
        class="mt-4 border-b"></p-tabMenu>
    </div>
    <div class="w-full p-2 m-2">
          <p-table
    #dt2
      dataKey="id"
      stripedRows
      [value]="filtered_invoices"
      responsiveLayout="scroll"
      [scrollable]="true"
      [resizableColumns]="true" 
      [autoLayout]="true"
      [paginator]="true"
      [rows]="50"
      selectionMode="single"
      [globalFilterFields]="['customer.name', 'created_at', 'due_date', 'status', 'including_tax']"
      (onRowSelect)="rowSelected()"
      [(selection)]="selectedInvoice"
      [tableStyle]="{ 'min-width': '50rem' }"
      [rowsPerPageOptions]="[50, 100, 200]"
    >
    <ng-template #emptymessage>
        <tr>
            <td colspan="6">No invoices found.</td>
        </tr>
    </ng-template>
    
    <!-- Table Header -->
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th pResizableColumn pSortableColumn="customer.name">
           Customer <p-sortIcon field="customer.name" />
          </th>
          <th pResizableColumn pSortableColumn="createdAt">
            Date <p-sortIcon field="createdAt" />
           </th>
           <th pResizableColumn pSortableColumn="createdAt">
            Due Date <p-sortIcon field="due_date" />
           </th>
           <th pResizableColumn pSortableColumn="status">
            Status <p-sortIcon field="status" />
           </th>
           <th pResizableColumn pSortableColumn="including_tax">
            Amount <p-sortIcon field="including_tax" />
           </th>
           <th></th>
         </tr>
         <tr>
          <th>
            <p-columnFilter type="text" field="customer.name"></p-columnFilter>
          </th>
           <th>
            <p-columnFilter type="date" field="createdAt"></p-columnFilter>
          </th>
            <th>
              <p-columnFilter type="date" field="due_date"></p-columnFilter>
            </th>
            <th>
              <p-columnFilter type="text" field="status"></p-columnFilter>
            </th>
            <th>
            </th>
            <th></th>
        </tr>
      </ng-template>

      <!-- Table Body -->
      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr [pSelectableRow]="rowData">
          <td>
            {{rowData.customer?.name}}
          </td>
          <td>
            {{rowData.createdAt | date}}
          </td>
          <td>
            {{rowData.due_date | date}}
          </td>
          <td>
            <span [ngClass]="rowData.status === 'PAID' ? 'green' : rowData.status === 'Pending' ? 'orange' : 'red'">
              {{rowData.status}}
            </span>
          </td>
          <td style="text-align: right">
            {{rowData.including_tax | currency: 'USD'}}
          </td>
          <td>
            <p-button (click)="activeItem = rowData; menu.toggle($event)" icon="pi pi-ellipsis-v"/>
          </td>
        </tr>
      </ng-template>
    </p-table>
    <p-menu appendTo="body" #menu [model]="items" [popup]="true" />
    </div>  
  </block-ui>
</div>
